import { QueryKeys, useCustomQuery } from './index';
import Config from '../../config';
import { BatchReportDetails, ArchiveCompanyCodes } from '../types/batchReports';

export const useBatchReportDetails = (id: number) => useCustomQuery<BatchReportDetails | null>(
  [QueryKeys.batchReports.BatchReport],
  {
    url: Config.endpoints.FETCH_BATCH_REPORT.replace(':batchReportId', id.toString()),
    errorMessage: 'Fetching Batch Report failed',
    defaultData: null,
    enabled: !!id,
  });


type ArchiveType = { periodName: string, entity: string };
export const useBatchReportArchiveCompanycodes = ({ periodName, entity }: ArchiveType) =>
  useCustomQuery<ArchiveCompanyCodes | null>(
    [QueryKeys.batchReports.BatchReportArchiveCompanyCodes],
    {
      url: Config.endpoints.FETCH_BATCH_REPORT_ARCHIVE_COMPANY_CODES
        .replace(/:periodName/, periodName)
        .replace(':entity', entity),
      errorMessage: 'Fetching Batch Report Archive Company Codes failed',
      defaultData: null,
      enabled: !!entity,
    });
